import React from 'react';
import SearchBar2 from '../SearchBar/SearchBar2';
import DataTable2 from '../DataTable2/DataTable2';
import Popup from '../Popups/Popup';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import DataTableDisplayLengthToggle from '../DataTable2/DataTableDisplayLengthToggle';
import Pagination from '../DataTable2/Pagination';
import Cell from '../DataTable2/DataTableComponents/Cell';
import UserActionsMenuList from '../UserActionsMenuList/UserActionsMenuList';
import EditGroupForm from './GroupMgmt/EditGroupForm';

export default class GroupsIndexCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			data: [],
			meta: {},
			loading: false,
			initialLoad: false,
			groupRequestType: '',
			groupName: '',
			groupUrl: '',
			isActionComplete: false,
			isCreateGroupFormPopupVisible: false,
			isGroupEditCardPopupVisible: false,
			isDeleteGroupCardPopupVisible: false,
			isSuccessCardPopupVisible: false,
			isTimeoutCardPopupVisible: false,
			isActionsMenuListVisible: false,
			sortOrder: 'asc',
			sortColumn: 'name',
			tempQuery: '',
			query: '',
			loading: false,
			loadingMessage: false,
			displayOptions: [
				10,
				25,
				50,
				100
			],
			groupId: null,
			currentPage: 0,
			pageLength: 25,
			pageNeighbours: 0
		};

		this.onChange = this.onChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onClearSearch = this.onClearSearch.bind(this);
		this.onSetGroupId = this.onSetGroupId.bind(this);
		this.onShowEditGroupPage = this.onShowEditGroupPage.bind(this);
		this.onChangeSortOrder = this.onChangeSortOrder.bind(this);
		this.onChangePageLength = this.onChangePageLength.bind(this);
		this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
		this.onShowCreateGroupFormPopup = this.onShowCreateGroupFormPopup.bind(
			this
		);
		this.onHideCreateGroupFormPopup = this.onHideCreateGroupFormPopup.bind(
			this
		);
		this.onShowDeleteGroupCardPopup = this.onShowDeleteGroupCardPopup.bind(
			this
		);
		this.onHideDeleteGroupCardPopup = this.onHideDeleteGroupCardPopup.bind(
			this
		);
		this.onShowSuccessCardPopup = this.onShowSuccessCardPopup.bind(this);
		this.onHideSuccessCardPopup = this.onHideSuccessCardPopup.bind(this);
		this.onShowTimeoutCardPopup = this.onShowTimeoutCardPopup.bind(this);
		this.onHideTimeoutCardPopup = this.onHideTimeoutCardPopup.bind(this);
		this.onShowGroupEditCardPopup = this.onShowGroupEditCardPopup.bind(this);
		this.onHideGroupEditCardPopup = this.onHideGroupEditCardPopup.bind(this);
		this.onShowActionsMenuList = this.onShowActionsMenuList.bind(this);
		this.onHideActionsMenuList = this.onHideActionsMenuList.bind(this);
	}

	render() {
		// console.log('GroupsIndexCard - Props', this.props);
		// console.log('GroupsIndexCard - State', this.state);

		let userParams = {
			//query: this.state.query,  //TODO: searching
			page: this.state.currentPage,
			results_per_page: this.state.pageLength,
			sort_column: this.state.sortColumn,
			sort_order: this.state.sortOrder,
		};
	  

		const userActionMenuStyles = this.state.isActionsMenuListVisible
			? {
					backgroundColor: 'white',
					padding: '8px',
					border: '1px solid #CED4DA',
					borderRadius: '5px',
					position: 'absolute',
					top: '0px',
					left: '0px',
					zIndex: '99',
					cursor: 'pointer'
				}
			: {};

		return (
			<div className="UsersIndexCard card">
				<div className="card-body">
					<div className="row">
						<div className="col-6">
							<h1 className="card-title">
								<div className="UsersTitle">
									{I18n.t('admin.groups')}{' '}
									<span>
										{this.state.meta.page ? (
											`(${this.state.meta.page.totalElements.toLocaleString()})`
										) : (
											''
										)}
									</span>
								</div>
							</h1>
						</div>
						<div className="col-6">
							<PopupWithUseClickOutside
								isPopupVisible={this.state.isCreateGroupFormPopupVisible}
								onHidePopup={this.onHideCreateGroupFormPopup}
							>
								<Popup
									title={
										this.state.groupRequestType === 'add' ? (
											<h1 className="card-title">
												{I18n.t('admin.create_group_title')}
											</h1>
										) : this.state.groupRequestType === 'edit' ? (
											<h1 className="card-title">
												{I18n.t('admin.edit_group_title')}
											</h1>
										) : (
											'Invalid Action - Please Contact Support'
										)
									}
									onHidePopup={this.onHideCreateGroupFormPopup}
								>
									<EditGroupForm
										iam_create_group_endpoint={
											this.props.iam_create_group_endpoint
										}
										iam_update_group_endpoint={
											this.props.iam_update_group_endpoint
										}
										iam_get_group_endpoint={this.props.iam_get_group_endpoint}
										onHidePopup={this.onHideCreateGroupFormPopup}
										onShowSuccessCardPopup={this.onShowSuccessCardPopup}
										onShowTimeoutCardPopup={this.onShowTimeoutCardPopup}
										onActionCompleted={this.onActionCompleted}
									/>
								</Popup>
							</PopupWithUseClickOutside>
							<PopupWithUseClickOutside
								isPopupVisible={this.state.isSuccessCardPopupVisible}
								onHidePopup={this.onHideSuccessCardPopup}
							>
								<Popup
									title={
										<h1 className="card-title" style={{ color: 'green' }}>
											{I18n.t('success_card_title')}
										</h1>
									}
								body={
									this.state.groupRequestType === 'add' ? (
										I18n.t('admin.success_create_group')
									) : this.state.groupRequestType === 'delete' ? (
										I18n.t('admin.success_delete_group')
									) : null
								}
									onHidePopup={this.onHideSuccessCardPopup}
								/>
							</PopupWithUseClickOutside>
							<PopupWithUseClickOutside
								isPopupVisible={this.state.isTimeoutCardPopupVisible}
								onHidePopup={this.onHideTimeoutCardPopup}
							>
								<Popup
									title={
										<h1 className="card-title" style={{ color: 'red' }}>
											{I18n.t('timeout_card_title')}
										</h1>
									}
									body={I18n.t('timeout_card_body')}
									onHidePopup={this.onHideTimeoutCardPopup}
								/>
							</PopupWithUseClickOutside>
							<PopupWithUseClickOutside
								isPopupVisible={this.state.isDeleteGroupCardPopupVisible}
								onHidePopup={this.onHideDeleteGroupCardPopup}
							>
								<Popup
									title={
										<h1 className="card-title">
											{I18n.t('admin.delete_group_title')}
										</h1>
									}
									body={
										<div>
											{this.state.groupName ? (
												I18n.t('admin.delete_group_body', {
													groupName: this.state.groupName
												})
											) : (
												"Are you sure you want to delete this group? This action can't be undone."
											)}
											<div style={{ float: 'right' }} className="mt-4">
												<button
													className="btn btn-secondary mx-2"
													onClick={this.onHideDeleteGroupCardPopup}
												>
													No, cancel
												</button>
												<button
													className="btn btn-primary"
													onClick={() => {
														this.onSetGroupRequestType('delete');
														this.deleteGroup(this.state.groupId);
													}}
												>
													Yes, delete
												</button>
											</div>
										</div>
									}
									onHidePopup={this.onHideDeleteGroupCardPopup}
								/>
							</PopupWithUseClickOutside>
							<button
								type="button"
								id="new-user"
								className="btn btn-primary"
								onClick={(e) => {
									this.onSetGroupRequestType('add');
									this.onShowCreateGroupFormPopup();
								}}
							>
								{I18n.t('admin.create_group')}
							</button>
						</div>
					</div>
					{/* Filter Section */}
					<div className="row filter-section">{/* SearchBar2 */}</div>
					<div className="row">
						<div className="col-12">
							{/* DataTable */}
							<DataTable2
								endpoint={this.props.iam_get_groups_endpoint}
								params={userParams}
								sortOrder={this.state.sortOrder}
								sortColumn={this.state.sortColumn}
								columns={[
									{
										displayName: 'Name',
										apiName: 'name',
										colNum: 1,
										colWidth: 25
									},
									{
										displayName: 'Description',
										apiName: 'description',
										colNum: 2,
										colWidth: 30,
										isSortable: false
									},
									{
										displayName: 'Created At',
										apiName: 'createdAt',
										colNum: 3,
										colWidth: 20,
										isSortable: false
									},
									{
										displayName: 'Updated At',
										apiName: 'updatedAt',
										colNum: 4,
										colWidth: 20,
										isSortable: false
									},
									{
										displayName: '',
										apiName: 'edit',
										colNum: 2,
										colWidth: '',
										isSortable: false
									}
								]}
								rowRenderer={(d) => {
									return (
										<tr key={d.id}>
											<td>
												<Cell value={d.name} />
											</td>
											<td>
												<Cell value={d.description} />
											</td>
											<td>
												<Cell value={d.createdAt} type="date" />
											</td>
											<td>
												<Cell value={d.updatedAt} type="date" />
											</td>
											<td>
												<Cell
													value={
														<div
															onClick={(e) => {
																e.stopPropagation();
																e.preventDefault();
																// console.log('click', d.id);
																this.onSetGroupId(d.id);
																this.onShowActionsMenuList(d.id);
															}}
														>
															<i
																className="fa fa-ellipsis-h"
																aria-hidden="true"
															/>
															<div style={{ position: 'relative' }}>
																<UserActionsMenuList
																	style={userActionMenuStyles}
																	data={[
																		{
																			id: 1,
																			type: 'edit',
																			displayName: 'Edit',
																			action: (e) => {
																				e.stopPropagation();
																				e.preventDefault();
																				this.onShowEditGroupPage();
																			}
																		},
																		{
																			id: 2,
																			type: 'delete',
																			displayName: 'Delete',
																			action: (e) => {
																				e.stopPropagation();
																				e.preventDefault();
																				this.onShowDeleteGroupCardPopup(
																					'delete',
																					d.name
																				);
																			}
																		}
																	]}
																	isMenuListVisible={
																		this.state.isActionsMenuListVisible === d.id
																	}
																	hideMenuList={this.onHideActionsMenuList}
																/>
															</div>
														</div>
													}
												/>
											</td>
										</tr>
									);
								}}
								onChange={this.onChange}
								onChangeSortOrder={this.onChangeSortOrder}
								isActionComplete={this.state.isActionComplete}
							/>
						</div>
					</div>
					<div className="row table-footer">
						<div className="col-12 col-sm-6">
							{/* Pagination */}
							<Pagination
								totalRecords={
									this.state.meta.page ? this.state.meta.page.totalElements : 0
								}
								pageLength={this.state.pageLength}
								currentPage={this.state.currentPage + 1}
								pageNeighbours={this.state.pageNeighbours}
								onChangeCurrentPage={this.onChangeCurrentPage}
							/>
						</div>
						<div className="col-12 col-sm-6">
							{/* DataTableDisplayLengthToggle */}
							<DataTableDisplayLengthToggle
								totalRecords={
									this.state.meta.page ? this.state.meta.page.totalElements : 0
								}
								displayOptions={this.state.displayOptions}
								pageLength={this.state.pageLength}
								onChangePageLength={this.onChangePageLength}
							/>
						</div>
					</div>
				</div>
				{/* Loading Overlay */}
				{this.state.loading ? (
					<div className="loadingOverlay">
						<div className="spinner" />
						{this.state.loadingMessage ? (
							<div className="loadingMessage">{this.state.loadingMessage}</div>
						) : null}
					</div>
				) : null}
			</div>
		);
	}

	onChange(event) {
		// console.log('event', event);
		const { name, value } = event.target;
		const { state } = this;
		state[name] = value;
		this.setState(state);
	}

	onSetUrlPath(urlPath) {
		this.setState({ groupUrl: urlPath });
	}

	onShowUserActionsMenuList = (id) => {
		// console.log('onShowUserActionsMenuList - id', id);
		this.setState({
			isActionsMenuListVisible: id
		});
	};

	onHideUserActionsMenuList = () => {
		this.setState({ isActionsMenuListVisible: false });
	};

	onShowDeleteGroupCardPopup(groupRequestType, groupName) {
		this.setState({
			groupRequestType: groupRequestType,
			groupName: groupName,
			isDeleteGroupCardPopupVisible: true,
			isActionsMenuListVisible: false
		});
	}

	onHideDeleteGroupCardPopup = () => {
		this.setState({
			isDeleteGroupCardPopupVisible: false
		});
	};

	deleteGroup(id) {
		$.ajax({
			type: 'DELETE',
			url: this.props.iam_delete_group_endpoint,
			data: {
				id: id
			}
		}).done((data) => {
			console.log('Done!', data);
			if (data.status == 'success') {
				// console.log('Group successfully deleted!', data);
				this.setState({
					loading: false
				});
				this.onHideDeleteGroupCardPopup();
				this.onShowSuccessCardPopup('delete');
				this.onActionCompleted();
			} else if (data.status == 'session_expired') {
				// console.log('Session expired!');
				this.onHideDeleteGroupCardPopup();
				this.onShowTimeoutCardPopup();
			} else {
				// console.log('Group delete failed!');
				this.setState({
					loading: false
				});
			}
		});
	}

	onShowSuccessCardPopup = () => {
		this.setState({
			isSuccessCardPopupVisible: true,
			sortOrder: 'desc',
			sortColumn: 'updatedAt',
			tempQuery: '',
			query: '',
			currentPage: 1
		});
	};

	onHideSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: false });
	};

	onActionCompleted = () => {
		this.setState({ isActionComplete: true });
		this.setState({ isActionComplete: false }); // Reset state for next action
	};

	onShowTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: true });
	};

	onHideTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: false });
	};

	onSearch(event) {
		event.preventDefault();
		// console.log('Query', event.target.value);
		this.setState({ query: this.state.tempQuery, currentPage: 0 });
	}

	onClearSearch(event) {
		event.preventDefault();
		// console.log('Clear Search Query', event.target.value);
		this.setState({ tempQuery: '', query: '', currentPage: 0 });
	}

	onChangeSortOrder(sortColumn, sortOrder) {
		// console.log('onChangeSortOrder', sortColumn, sortOrder);
		if (sortOrder === '' || sortOrder === 'desc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'asc',
				currentPage: 0
			});
		} else if (sortOrder === 'asc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'desc',
				currentPage: 0
			});
		}
	}

	onChangeCurrentPage(currentPage) {
		this.setState({ currentPage: currentPage - 1 });
	}

	onChangePageLength(pageLength) {
		// console.log('onChangePageLength' , pageLength);
		this.setState({ pageLength: pageLength, currentPage: 0 });
	}

	onShowCreateGroupFormPopup = () => {
		this.setState({ isCreateGroupFormPopupVisible: true });
	};

	onHideCreateGroupFormPopup = () => {
		this.setState({ isCreateGroupFormPopupVisible: false });
	};

	onShowSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: true });
	};

	onHideSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: false });
	};

	onShowTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: true });
	};

	onHideTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: false });
	};

	onShowGroupEditCardPopup() {
		this.setState({ isGroupEditCardPopupVisible: true });
	}

	onHideGroupEditCardPopup = () => {
		this.setState({ isGroupEditCardPopupVisible: false });
	};

	onSetGroupId = (id) => {
		this.setState({ groupId: id });
	};

	onSetGroupRequestType = (type) => {
		this.setState({ groupRequestType: type });
	};

	onShowActionsMenuList = (id) => {
		this.setState({
			isActionsMenuListVisible: id
		});
	};

	onHideActionsMenuList = () => {
		this.setState({ isActionsMenuListVisible: false });
	};

	onShowEditGroupPage() {
		this.setState({
			loading: true,
			loadingMessage: I18n.t('admin.group.editing'),
			isActionsMenuListVisible: false
		});
		window.location.href = `/admin/${this.props.public_id}/groups/edit/${this
			.state.groupId}`;
	}
}
